// v-loadmore: 用于在element-ui的select下拉框加上滚动到底事件监听

Vue.directive('loadmore', {
  bind (el, binding) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')

    SELECTWRAP_DOM.addEventListener('scroll', function () {
      /*
         * scrollHeight 获取元素内容高度(只读)
         * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
         * clientHeight 读取元素的可见高度(只读)
         * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
         * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
         */
      const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight

      if (CONDITION) {
        binding.value()
      }
    })
  }
})
Vue.directive('enterNumber', {
  inserted: function (el) {
    const INPUT_DOM = el.querySelector('.el-input__inner')
    INPUT_DOM.addEventListener('keypress', function (e) {
      e = e || window.event
      let charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode
      let re = /\d/
      if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
      }
    })
  }
})
Vue.directive('enterNumber2', {
  inserted: function (el) {
    const INPUT_DOM = el.querySelector('.el-input__inner')
    INPUT_DOM.addEventListener('keypress', function (e) {
      e = e || window.event
      let charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode
      let re = /\d/
      if (charcode === 46) {
        if (e.target.value.includes('.')) {
          e.preventDefault()
        }
      } else if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/utils/directives.js